import {IUnrealVector, IVscCommunityMapCameraInfo} from "../../visualizers/IVscCommunityMapInfo";

import {IViewCamera, IViewItemImage, IViewMap, IViewVideo} from "../../data/IViewpoint";


export function vectorToString(vector:IUnrealVector) {
    return `[${vector.x.toFixed(4)}, ${vector.y.toFixed(4)}, ${vector.z.toFixed(4)}]`;
}
function findCamera(enabledCameras:IViewCamera[], cameraId:string) {
    return enabledCameras.find(ec => ec.camera.toLowerCase() === cameraId.toLowerCase());

}
const CameraAdminInfo: React.FC<{
    cameras: IVscCommunityMapCameraInfo[],
    onViewCamera: (cameraId: string) => void,
    enabledCameras: IViewCamera[]
}> = (props) => {


    const { cameras, enabledCameras, onViewCamera } = props;
    return <table>
        <tr>
            <th>Id</th>
            <th>Controller</th>
            <th>Location</th>
            <th>LookAtDirection</th>
        </tr>
        {cameras.map(c => <tr style={{backgroundColor: findCamera(enabledCameras, c.cameraId) ? "lightgreen" : "inherit"}}>
            <td><a href={'#'} onClick={(ev) => {
                onViewCamera(c.cameraId);
                ev.preventDefault();
                return false;
            }}>{c.cameraId}</a></td>
            <td>{ findCamera(enabledCameras, c.cameraId)?.name } </td>
            <td>{vectorToString(c.location)}</td>
            <td>{vectorToString(c.lookAtDirection)}</td>

        </tr>)}
    </table>
}

export default CameraAdminInfo;